import React from 'react';

const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen bg-slate-900 text-white">
      <div className="max-w-4xl mx-auto py-12 px-4 sm:px-6 lg:px-8">
        <h1 className="text-4xl font-bold text-white mb-8">Privacy Policy</h1>
        
        <div className="prose prose-invert max-w-none">
          <p className="text-lg text-slate-400 mb-8">
            Last updated: February 11, 2024
          </p>

          {/* 1. Introduction */}
          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-white mb-4">1. Introduction</h2>
            <p className="text-slate-300 mb-4">
              At <strong>DeckLink</strong>, we understand the sensitive nature of real estate transactions 
              and are committed to protecting your privacy and the confidentiality of your deal room data. 
              This privacy policy outlines how we collect, use, and safeguard your information. 
              For any questions, please contact us at <strong>davies@decklink.co</strong>.
            </p>
          </section>

          {/* 2. Account Creation and Information Collection */}
          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-white mb-4">2. Account Creation and Information Collection</h2>
            <p className="text-slate-300 mb-4">
              When you create an account with DeckLink, we collect essential information including your 
              name, email address, company details, and a secure password. This information enables us 
              to provide you with a secure virtual deal room experience, manage your account, and offer 
              professional support for your real estate transactions.
            </p>
          </section>

          {/* 3. Deal Room Data Security */}
          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-white mb-4">3. Deal Room Data Security</h2>
            <p className="text-slate-300 mb-4">
              Your deal room data, including property information, financial documents, and transaction 
              details, are stored with bank-grade encryption. We implement strict access controls and 
              multi-factor authentication to ensure that only authorized users can access sensitive 
              information within your virtual deal room.
            </p>
          </section>

          {/* 4. Analytics and Performance Monitoring */}
          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-white mb-4">
              4. Analytics and Performance Monitoring
            </h2>
            <p className="text-slate-300 mb-4">
              We use analytics tools to monitor platform performance and user engagement patterns. 
              This helps us improve our services and provide better support for your real estate 
              transactions. All analytics data is anonymized and used solely for service improvement.
            </p>
          </section>

          {/* 5. Document Management and Sharing */}
          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-white mb-4">
              5. Document Management and Sharing
            </h2>
            <p className="text-slate-300 mb-4">
              Documents uploaded to your virtual deal room are encrypted and stored securely. 
              You maintain full control over document sharing permissions, and we provide 
              detailed audit logs of all document access and modifications.
            </p>
          </section>

          {/* 6. AI-Powered Features */}
          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-white mb-4">6. AI-Powered Features</h2>
            <p className="text-slate-300 mb-4">
              Our AI features process deal room data to provide insights and recommendations. 
              This processing is conducted securely within our platform, and your data is never 
              shared with third parties or used for purposes other than improving your deal room experience.
            </p>
          </section>

          {/* 7. Communication and Notifications */}
          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-white mb-4">7. Communication and Notifications</h2>
            <p className="text-slate-300 mb-4">
              We may send you important updates about your deal room, security notifications, 
              and service improvements. You can manage your communication preferences in your 
              account settings.
            </p>
          </section>

          {/* 8. Data Retention */}
          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-white mb-4">8. Data Retention</h2>
            <p className="text-slate-300 mb-4">
              We retain your deal room data for as long as your account is active and as needed 
              to provide our services. Upon account closure, we securely archive your data for 
              a limited period before permanent deletion, in compliance with legal requirements.
            </p>
          </section>

          {/* 9. Updates to Our Privacy Policy */}
          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-white mb-4">9. Updates to Our Privacy Policy</h2>
            <p className="text-slate-300 mb-4">
              We may update this privacy policy to reflect changes in our practices or legal requirements. 
              We will notify you of any significant changes through our platform or via email.
            </p>
            <p className="text-slate-300 mb-4">
              By using DeckLink, you agree to our collection and use of information as described 
              in this policy. Continued use of our services after any changes constitutes acceptance 
              of the updated terms.
            </p>
          </section>

          {/* 10. Contacting Us */}
          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-white mb-4">10. Contacting Us</h2>
            <p className="text-slate-300 mb-4">
              For privacy-related questions or concerns, please contact us at{" "}
              <strong>davies@decklink.co</strong>.
            </p>
            <p className="text-slate-300 mb-4">
              DeckLink is committed to protecting your privacy and maintaining the security 
              of your real estate transaction data in accordance with applicable laws and 
              industry best practices.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
